export default {
  header: {
    home: "首页",
    products: "产品中心",
    product: "产品中心",
    about: "品牌介绍",
    service: "媒体中心",
    contact: "联系我们",
    buyOnline: "在线购买"
  },
  common: {
    loading: "加载中...",
    error: "加载失败，请稍后重试",
    noData: "暂无数据"
  },
  hero: {
    title1: "路不易",
    title2: "有神翼",
    subtitle: "神翼领航员系列全新上市重磅首发",
    cta: "了解更多",
    carImageAlt: "神翼轮胎展示"
  },
  about: {
    title: "品牌故事",
    subtitle: "神翼轮胎是韩国耐克森集团旗下战略品牌",
    content: "神翼轮胎是一款致力于用先进技术解决新时代日常出行中驾驶难题的轮胎品牌，研发团队始终秉承 \"为用户创造美好出行体验\" 的品牌愿景，通过优化材料配方、创新花纹和结构设计，不断突破技术边界、打磨产品，帮助用户提升出行品质，即使是恶劣气候和复杂路况，也能在保障安全的同时，提供良好的操控和驾乘体验。",
    more: "了解更多",
    brandName: "神翼轮胎",
    brandSub: "SHENYI",
  },
  products: {
    title: "精选轮胎",
    viewMore: "查看更多",
    buyNow: "立即购买",
    priceFrom: "价格从",
    series: {
      all: "全部系列"
    },
    product1: {
      name: "UltraContact UX7",
      desc: "韧范无穷 铭刻呼啸"
    },
    product2: {
      name: "UltraContact UX7",
      desc: "驾控自由 舒适随行"
    },
    product3: {
      name: "UltraContact UX7",
      desc: "大幅节能 回转精准"
    }
  },
  technology: {
    title: "我们的创新科技",
    subtitle: "神翼是一家知名轮胎公司，为各种需求提供广泛的有用服务。",
    tech1: {
      title: "得心应手 稳控随心",
      desc: "采用深度神经网络方法，配合德国人工智能持续训练的GCC3自适应方程组，行车更平顺自然，驾控更随心"
    },
    tech2: {
      title: "湿地无忧 安全有力",
      desc: "采用深度神经网络方法，配合德国人工智能持续训练的GCC3自适应方程组，行车更平顺自然，驾控更有力"
    },
    tech3: {
      title: "更舒适 更安全",
      desc: "采用深度神经网络方法，配合德国人工智能持续训练的GCC3自适应方程组，行车更平顺自然，驾控更舒适"
    },
    tech4: {
      title: "高里程耐磨科技",
      desc: "采用先进材料和优化结构设计，大幅提升轮胎耐磨性和使用寿命，保障长途行驶安全可靠。"
    }
  },
  footer: {
    products: "产品中心",
    about: "关于我们",
    interact: "关注我们",
    company: "公司简介",
    history: "发展历程",
    wechat: "微信",
    tiktok: "抖音",
    contact: "客服热线",
    needHelp: "需要轮胎帮助吗？请致电"
  },
  blog: {
    title: "媒体中心",
    noData: "暂无媒体内容",
    loadFailRetry: "获取媒体信息失败，请稍后重试"
  }
}
